import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import useAxios from "../../Utils/useAxios";
import getUMKCheck from "../../Component/Uang Muka/UMK/services/getUMKCheck";

const ProtectedUMK = ({ children }) => {
  const location = useLocation();
  const axiosInstance = useAxios();
  const [isLoading, setIsLoading] = useState(true);
  const [isAllowed, setIsAllowed] = useState(false);

  useEffect(() => {
    checkUser();
  }, []);

  const checkUser = async () => {
    try {
      const eligible = await getUMKCheck(axiosInstance);

      if (eligible.status === 204) {
        setIsAllowed(true);
      } else if (eligible.status === 200) {
        setIsAllowed(false);
      }
    } catch (error) {
      console.error("Error checking UMK status:", error);
      setIsAllowed(false);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isAllowed) {
    return (
      <Navigate
        to={`${process.env.PUBLIC_URL}/umk`}
        state={{ from: location }}
        replace
      />
    );
  }

  return children;
};

export default ProtectedUMK;
